import React, { useEffect, useState } from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import _ from 'lodash';

import ContainerReport from '../../../../ContainerReport';
import iconData from '../../../../../../../assets/images/data.svg';

import '../../../../BotReport/index.css';

const CHART_INITIAL_STATE = {
  chart: {
    type: 'column',
    width: 850,
    height: 250,
    style: {
      fontFamily: 'Fira Sans',
    },
  },
  series: [],

  title: {
    text: '',
  },

  xAxis: {
    categories: [],
  },

  yAxis: {
    allowDecimals: false,
    min: 0,
    title: {
      text: '',
    },
  },

  tooltip: {
    useHTML: true,
    opacity: 1,
    backgroundColor: '#2B323D',
    borderColor: '#2B323D',
    borderRadius: 10,
    formatter() {
      if (this.y <= 0) {
        return false;
      }
      return `<table style="color: white;"><tr><td style="text-align: center;">${this.x}</td></tr><tr><td style="text-align: center; color: white;">${this.y}</td></tr><tr><td style="text-align: center; color: white;">${this.series.name}</td></tr></table>`;
    },
  },

  plotOptions: {
    column: {
      stacking: 'normal',
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    align: 'left',
    x: 20,
  },
  exporting: {
    enabled: false,
  },
};

const OrgBotTotalConsumptionGraphic = ({ data }) => {
  const [chartOptions, setChartOptions] = useState(CHART_INITIAL_STATE);

  const updateChart = () => {
    const allSeries = [];

    data.forEach((chart) => {
      const singleSeries = chart?.bots?.map((bot) => {
        return {
          name: bot.botName,
          data: data.map((cat) => {
            const result = cat?.bots?.find((count) => {
              return count.botName === bot.botName;
            });
            return result ? result.count : 0;
          }),
        };
      });
      allSeries.push(...singleSeries);
    });

    // removes os valores repeditos da lista de series
    const series = allSeries
      .map((el) => JSON.stringify(el))
      .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
      .map((el) => JSON.parse(el));

    const categories = data.map((cat) => {
      return cat._id;
    });

    const chart = {
      ...chartOptions,
      series,
      xAxis: {
        categories,
      },
    };
    setChartOptions(chart);
  };

  useEffect(() => {
    updateChart();
  }, [data]);

  /**
   * Render report container content for the current report component
   */
  const renderContainerContent = () => {
    return (
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        allowChartUpdate
      />
    );
  };

  return (
    <ContainerReport
      type="graphic"
      icon={iconData}
      title="Quantidade de sessões"
      containerContent={renderContainerContent()}
    />
  );
};

export default OrgBotTotalConsumptionGraphic;
